var CIDSerialiser = require('conversation/conversation-id-serialiser');
var Codec = require('io/codec');

module.exports = {
    read : function(bis) {
        return {
            cid : CIDSerialiser.read(bis),
            path : bis.readString(),
            id : bis.readInt32(),
            bytes : bis.readBytes()
        };
    },
    write : function(bos, req) {
        CIDSerialiser.write(bos, req.cid);
        Codec.writeString(bos, req.path);
        Codec.writeInt32(bos, req.id);
        Codec.writeBytes(bos, req.bytes);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-delta-request-serialiser.js
// module id = 1031
// module chunks = 1